import { render, staticRenderFns } from "./DefaultComponent.vue?vue&type=template&id=3ec0b38e&scoped=true"
import script from "./DefaultComponent.vue?vue&type=script&lang=js"
export * from "./DefaultComponent.vue?vue&type=script&lang=js"
import style0 from "./DefaultComponent.vue?vue&type=style&index=0&id=3ec0b38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec0b38e",
  null
  
)

export default component.exports